import { supabase } from '../lib/supabase.js';

export async function saveGameResult({ userId, won, cardsPlayed, roundTimeSeconds }) {
  console.log("saveGameResult called:", { userId, won });
  if (!userId) { console.log("No userId - not saving"); return; }

  try {
    // Try to get existing stats
    const { data: existing, error } = await supabase
      .from('stats')
      .select('*')
      .eq('id', userId)
      .single();

    // If no row exists, create one first
    if (error || !existing) {
      await supabase.from('stats').insert({
        id: userId,
        wins: won ? 1 : 0,
        losses: won ? 0 : 1,
        current_streak: won ? 1 : 0,
        win_streak: won ? 1 : 0,
        cards_played: cardsPlayed || 0,
        fastest_round: won ? roundTimeSeconds : null,
      });
      console.log("Created new stats row");
      return;
    }

    const newWins = won ? existing.wins + 1 : existing.wins;
    const newLosses = won ? existing.losses : existing.losses + 1;
    const newStreak = won ? existing.current_streak + 1 : 0;
    const newBestStreak = Math.max(existing.win_streak || 0, newStreak);
    const newCardsPlayed = (existing.cards_played || 0) + (cardsPlayed || 0);
    const newFastest = won
      ? existing.fastest_round
        ? Math.min(existing.fastest_round, roundTimeSeconds)
        : roundTimeSeconds
      : existing.fastest_round;

    const { error: updateError } = await supabase
      .from('stats')
      .update({
        wins: newWins,
        losses: newLosses,
        current_streak: newStreak,
        win_streak: newBestStreak,
        cards_played: newCardsPlayed,
        fastest_round: newFastest,
      })
      .eq('id', userId);

    if (updateError) console.error("Stats update error:", updateError);
    else console.log("Stats saved successfully!");

  } catch (err) {
    console.error("Error saving stats:", err);
  }
}

export async function loadStats(userId) {
  if (!userId) return null;
  const { data } = await supabase
    .from('stats')
    .select('*')
    .eq('id', userId)
    .single();
  return data;
}

export function formatTime(seconds) {
  if (!seconds) return "--";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}
